import { Injectable } from '@angular/core';
import { Apollo, Query, gql } from 'apollo-angular';
import { ContractDetails, ContractDetailsResponse } from './contract.model';

const ContractPDFQuery = gql`
  query ContractPDFQuery($id: String!) {
    contractPdf(id: $id) {
      filename
      body
    }
  }
`;

const ContractDetailsQuery = gql`
  query ContractDetailQuery($id: String!) {
    contract(id: $id) {
      _id
      createdAt
      contract_number

      buyer_id
      seller_id

      lot_id
      negotiation_id
      terms_and_conditions

      lot_type

      origin
      #crop_year
      commodity
      product_type
      grade
      specifications {
        title
        value
      }
      documentations {
        title
        value
      }
      price {
        __typename
        ... on CashPrice {
          amount
        }

        __typename
        ... on BasisPrice {
          month
          year
          basisPoints
          product_code
        }
      }
      currency
      volume_value
      units
      tolerance
      ship_begin
      ship_end
      delivery_type
      delivery_option
      container_type
      destination
      rules_to_govern
      weight_grade_to_govern
      payment_term
      terms_and_conditions
      additional_info

      buyer_email
      buyer_first_name
      buyer_last_name
      buyer_company_name
      buyer_address_mail
      buyer_address_mail_line2
      buyer_address_mail_city
      buyer_address_mail_province
      buyer_address_mail_country
      buyer_address_mail_postal_code
      buyer_mailing_address_long
      buyer_fax_number
      buyer_work_phone
      buyer_cell_phone

      seller_email
      seller_first_name
      seller_last_name
      seller_company_name
      seller_address_mail
      seller_address_mail_line2
      seller_address_mail_city
      seller_address_mail_province
      seller_address_mail_country
      seller_address_mail_postal_code
      seller_mailing_address_long
      seller_fax_number
      seller_work_phone
      seller_cell_phone
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ContractDetailsService {
  constructor(private apollo: Apollo) {}

  getPDF(contractId: string) {
    return this.apollo.watchQuery({
      query: ContractPDFQuery,
      variables: {
        id: contractId,
      },
    });
  }

  contractDetails(contractId: string) {
    return this.apollo.watchQuery({
      query: ContractDetailsQuery,
      variables: {
        id: contractId,
      },
    });
  }
}
